<template>
  <div>
    <p v-for="(item,index) in renderText(textNote)" :key="'link'+index">
      <a :href="item" class="style-tag-link" target="_blank">Link {{index + 1}}</a>
    </p>
    <p v-if="!isShowFull && textNote.length > 2">
      <span class="text-info" @click="showAll()">
        <v-icon>mdi-chevron-down</v-icon>
      </span>
    </p>
    <p v-if="isShowFull && textNote.length > 2">
      <span class="text-info" @click="hideLess()">
        <v-icon>mdi-chevron-up</v-icon>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    textNote: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isShowFull: false,
    };
  },
  methods: {
    renderText(text) {
      if (this.isShowFull) {
        return text;
      }
      return text.length > 2 ? text.slice(0, 2) : text;
    },
    showAll() {
      this.isShowFull = true;
    },
    hideLess() {
      this.isShowFull = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-info {
  color: #1187ca;
}
.style-tag-link {
  color: #08F;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
